import { render } from "./CreateExpenseType.vue?vue&type=template&id=33230611"
import script from "./CreateExpenseType.vue?vue&type=script&lang=js"
export * from "./CreateExpenseType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__